import Vue from 'vue';

export function setNormalizeEntities(storeEntitiesKey = 'entities') {
  return (state, entities) => {
    Object.entries(entities).forEach(([type, entities]) => {
      if (!state[storeEntitiesKey][type]) {
        Vue.set(state[storeEntitiesKey], type, {});
      }

      Object.entries(entities).forEach(([key, entity]) => {
        const oldEntity = state[storeEntitiesKey][type][key] || {};

        const newEntity = {
          ...oldEntity,
          ...entity
        };

        Vue.set(state[storeEntitiesKey][type], key, newEntity);
      });
    });
  };
}
